import {
  formatDate,
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_POSTS } from './constants';

const initialState = {
  primaryPost: null,
  secondaryPost: null,
  results: [],
  isFetching: false,
  fetchingErrors: null
};

function formatNewsDate(post) {
  if (!post) {
    return post;
  }

  return Object.assign({}, post, {
    dateDisplay: formatDate(post.datePublished)
  });
}

export default createReducer(initialState, {
  [GET_POSTS]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        const {
          primaryPost,
          secondaryPost,
          results
        } = action.request.response;

        const items = results.filter(item =>
          item.id !== primaryPost.id &&
          item.id !== secondaryPost.id);

        return Object.assign(state, {
          primaryPost: formatNewsDate(primaryPost),
          secondaryPost: formatNewsDate(secondaryPost),
          results: items.map(formatNewsDate),
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/Posts/reducer.js